<template>
  <BaseModal v-model="show" v-bind="$attrs" :width="420">
    <a-tabs type="card" :tabBarGutter="5">
      <a-tab-pane key="1" tab="余额支付">
        <a-alert show-icon type="warning">
          <template slot="message">
            当前账户余额{{ user.stats["balance"]|formatCNF }}。
            <router-link :to="{name:'UCenter.Income'}">去充值</router-link>
          </template>
        </a-alert>
        <div style="margin:40px 0 10px 0;text-align:center;">
          <a-empty v-if="overdue" description="请充值或使用扫码支付"/>
          <a-button v-else size="large" shape="round" @click="callPrepay" type="primary" :loading="loading">
            确认支付{{ amount|formatCNF }}
          </a-button>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="扫码支付">
        <a-alert show-icon type="warning">
          <template slot="message">
            请使用微信或支付宝扫码支付{{ amount|formatCNF }}
          </template>
        </a-alert>
        <a-row :gutter="20" style="margin-top:20px;">
          <a-col span="12">
            <div class="qrcode">
              <img :src="wxCode" width="160" height="160"/>
              <div>微信扫码支付</div>
            </div>
          </a-col>
          <a-col span="12">
            <div class="qrcode">
              <img src="@/assets/waiting.jpg" width="160" height="160"/>
              <div>支付宝扫码支付</div>
            </div>
          </a-col>
        </a-row>
      </a-tab-pane>
    </a-tabs>
  </BaseModal>
</template>

<script>
import api from "@/utils/api";
import func from "@/utils/func";
import BaseModal from "@/comps/BaseModal";
import DelayLoading from "@/comps/DelayLoading";

export default {
  name: "CommonPay",
  mixins: [DelayLoading],
  components: {BaseModal},
  props: {
    user: Object,
    wxpay: Function,
    alipay: Function,
    prepay: Function,
    probe: Function,
  },
  data() {
    return {
      show: false,
      wxCode: "",
      aliCode: "",
      amount: 0,
      probeTimeId: null,
    }
  },
  computed: {
    overdue() {
      return this.user.stats["balance"] < this.amount;
    }
  },
  methods: {
    open(amount) {
      const self = this;
      this.show = true;
      this.amount = amount;
      clearTimeout(this.probeTimeId);
      if (func.isDefined(this.wxpay)) {
        this.wxpay().then(res => {
          self.wxCode = api.v1.support.qrCode(res["pay_args"]["code_url"], 200);
          self.callProbe(res.info["trade_no"]); // 探测
        });
      }
      if (func.isDefined(this.alipay)) {
        this.alipay().then(res => {
          self.aliCode = api.v1.support.qrCode(res["pay_args"]["code_url"], 200);
          self.callProbe(res.info["trade_no"]); // 探测
        });
      }
    },
    async callProbe(id) {
      let paid = await this.probe(id);
      if (paid) this.$emit("paid");
      else {
        this.probeTimeId = func.setTimeout(2000, () => this.callProbe(id));
      }
    },
    callPrepay() {
      return this.withLoading(300, this.prepay).then(() => this.$emit("paid"));
    }
  }
}
</script>

<style scoped lang="less">
.qrcode {
  padding: 6px;
  text-align: center;
  border-radius: 3px;
  border: 1px #ddd solid;

  img {
    max-width: 100%;
    margin-bottom: 8px;
  }
}
</style>